/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusResourceNone({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        d="M128.785 43.253c7.975 0 14.435 6.484 14.435 14.472v45.183a1.251 1.251 0 0 1-2.5 0V57.725c0-6.614-5.348-11.971-11.935-11.971H72.446c-6.587 0-11.934 5.357-11.934 11.97v78.058c0 6.613 5.347 11.971 11.934 11.971h27.716a1.25 1.25 0 0 1 0 2.5H72.446c-7.974 0-14.434-6.483-14.434-14.471V57.725c0-7.988 6.46-14.472 14.434-14.472z"
      />
      <path
        fill="#B6BAC1"
        d="M64.884 75.34c11.66 0 21.113-9.479 21.113-21.17S76.544 33 64.884 33s-21.112 9.478-21.112 21.17c0 11.691 9.452 21.17 21.112 21.17"
      />
      <path
        fill="#fff"
        d="M56.612 54.128c0-6.663 2.952-11.652 8.314-11.652 6.571 0 8.23 6.182 8.23 11.63 0 6.015-2.16 11.757-8.168 11.768-5.893 0-8.365-5.188-8.376-11.736zm4.33-.115c0 5.083 1.334 8.127 4.046 8.127s3.891-2.835 3.88-8.065c0-5.449-1.366-7.949-4.015-7.949-2.285 0-3.922 2.406-3.922 7.887z"
      />
      <circle cx={121.271} cy={125.5} r={20.5} fill="#F9FAFB" />
      <path
        fill="#FAE100"
        d="M120.991 101c13.35 0 24.211 10.86 24.221 24.22 0 4.94-1.49 9.54-4.04 13.37l11.88 11.94.01.01a4.645 4.645 0 0 1-6.59 6.55l-11.821-11.88c-3.89 2.67-8.6 4.23-13.66 4.23-13.36 0-24.22-10.86-24.22-24.22s10.87-24.22 24.22-24.22m0 8.75c-8.53 0-15.469 6.95-15.47 15.47 0 8.52 6.95 15.46 15.47 15.46s15.46-6.93 15.46-15.46-6.93-15.47-15.46-15.47"
      />
    </svg>
  );
}
export default IllustStatusResourceNone;
